/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Down Icon component.
 */
const SystemDownIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4 10.6177L7.67148 14.0001L11.1912 10.6177' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M7.5918 3V12.8581' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default React.memo(SystemDownIcon);
